import { AccessTypes } from '../../common/domain/accountAccessType';

export interface ISignUpCredentialsByEmail {
  email: string;
}

export enum RecaptchaActions {
  SignUp = 'SIGN_UP',
  CheckEmail = 'CHECK_EMAIL',
  SignUpByEmail = 'SIGN_UP_BY_EMAIL',
  ProSignUp = 'PRO_SIGN_UP',
  ResendSignUpEmail = 'RESEND_SIGN_UP_EMAIL',
  Login = 'LOGIN'
}

export type SignUpTier = AccessTypes.Professional | AccessTypes.Lite;
